import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactZmartaNoConfig } from './presets/contact-zmarta-no.config';
import { globalNo } from './presets/global-no.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { organisationZmartaNoConfig } from './presets/organisation-zmarta-no.config';
import { serviceTrustpilotAxoConfig } from './presets/service-trustpilot-axo.config';
import { sitePathZmartaNoConfig } from './presets/site-path-zmarta-no.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansNoConfig } from './presets/unsecured-loans-no.config';

export const global: GlobalConfig = {
  brand: 'zmarta.no',
  ...globalNo,
};

export const site: SiteConfig = {
  domain: 'zmarta.no',
  name: 'Zmarta',
  theme: {
    name: 'zmarta',
    brand: 'zmarta.axo',
  },
  ...sitePathZmartaNoConfig,
  ...organisationZmartaNoConfig,
  ...contactZmartaNoConfig,
  services: {
    trustpilot: {
      ...serviceTrustpilotAxoConfig,
      businessUnitId: '5526aba10000ff00057ea771',
    },
    gtm: 'GTM-5S75TD5D',
    ga: 'G-3S6E9KW16R',
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansNoConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: { hasHighCostWarning: false, ...myPageOffersConfig },
};
